import React from "react";
import {
  Card,
  CardBody,
  CardHeader,
  CardFooter,
  CardTitle,
  Form,
  FormGroup,
  FormText,
  Input,
  Table,
  Label,
  Row,
  Col
} from "reactstrap";
import Select from "react-select";
import CKEditor from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

import Image from "react-image";

import axios from "axios";

import { Redirect } from "react-router-dom";

import { PanelHeader, Button, Statistics, Timeline } from "components";

import { theadwebmobilerequests, tbody } from "variables/general";
import SweetAlert from "react-bootstrap-sweetalert";
import { Link } from "react-router-dom";
// react plugin used to create charts
import { Line } from "react-chartjs-2";
import { dashboardPanelChart } from "variables/charts.jsx";
import moment from "moment";
import "moment/locale/es";

var dashboardOrdersTitleStyle = {
  margin: "0 0 20px 20px",
  color: "#FFF"
};
var noteType = [
  { value: "59", label: "General" },
  { value: "60", label: "Incidencia" },
  { value: "62", label: "Log" },
  { value: "61", label: "Solución" },
  { value: "214", label: "Devolución" }
  /*,
  { value: "three", label: "Baja" },
  { value: "four", label: "Suspensión por impago" },
  { value: "five", label: "Cambio de nombre" },
  { value: "six", label: "Cambio de tarifa" }*/
];
//function to group array by param. Usage:
//        const groupByParamA = groupBy('paramA');
//        const groupedElements = groupByParamA(elements);
const groupBy = key => array =>
  array.reduce((objectsByKeyValue, obj) => {
    const value = obj[key];
    objectsByKeyValue[value] = (objectsByKeyValue[value] || []).concat(obj);
    return objectsByKeyValue;
  }, {});

class WebContentDetails extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isGettingWebform: false,
      webform: null
    };
    this.redirectTo = this.redirectTo.bind(this);
    this.getWebform = this.getWebform.bind(this);
    this.buildContent = this.buildContent.bind(this);
    this.buildWebforms = this.buildWebforms.bind(this);
    this.createWebformsTable = this.createWebformsTable.bind(this);
    this.buildWebformDetailsInTable = this.buildWebformDetailsInTable.bind(this);
    this.createNotes = this.createNotes.bind(this);
    this.validateNote = this.validateNote.bind(this);
    this.clearNote = this.clearNote.bind(this);
    this.newNote = this.newNote.bind(this);
    this.filterNotes = this.filterNotes.bind(this);
  }
  componentDidMount() {
    this.setState({ isGettingWebform: true });
    let webformId = this.props.match.params.webformId;
    this.getWebform(webformId);
  }
  getWebform(webformId) {
    this.props.userData.getWebform(webformId).then(result => {
        // console.log("################## RESPUESTA OBTENER WEBFORM ################");
        // console.log(result);
        this.setState({ isGettingWebform: false });

        let response = result; // result.data;
        if (response.result === "OK") {
          this.setState({ webform: response.webform });
        } else {
          // this.showError(response.error);
          console.log("Error al obtener los contratos del cliente", response.error);
        }
      })
      .catch((error) => {
        // Error 😨
        this.setState({ isGettingWebform: false });
        console.log("Error al obtener el webform " + webformId, error);
        // this.showError("Error al obtener los contratos relacionados, vuelve a intentarlo en un momento. (" + error + ")");
      });
  }
  componentDidUpdate(prevProps, prevState) {
    // console.log("webContent props", this.props);
    // console.log("webContent mainState", this.props.mainState);
    if (prevProps.mainState.isCreatingNote !== this.props.mainState.isCreatingNote) {
      this.getWebform(this.state.webform.id);
    }
  }
  redirectTo(redirect) {
    this.props.history.push(redirect);
  }
  filterNotes(note) {
    if (!this.state.noteFilter) return true;
    let note_text = note.texto;
    let noteFilter = this.state.noteFilter.toLowerCase();
    // console.log("note_text", note_text);
    try {
      let note_json = JSON.parse(note_text);
      // console.log("note_json", note_json);
      note_text = note_json.text;
    } catch (error) {
      // console.log("error", error);
      note_text = note.texto;
    }

    let subFilters = noteFilter.toLowerCase().split(" ");
    let result = true;
    if (!subFilters || subFilters.length === 0) {
      return result;
    }
    // console.log("subFilters",subFilters);
    subFilters.map(filter => {
      let localResult = false;
      // Si cualquiera de las condiciones se cumple, devuelve TRUE
      if (note_text.toLowerCase().includes(filter)) localResult = true;
      if (note.fecha.toLowerCase().includes(filter)) localResult = true;
      if (note.tipo.toLowerCase().includes(filter)) localResult = true;
      if (note_text.toLowerCase().includes(filter)) localResult = true;
      if (note.autor.toLowerCase().includes(filter)) localResult = true;
      if (note.titulo.toLowerCase().includes(filter)) localResult = true;

      result = result && localResult;
    });
    return result;
  }
  createWebformsTable(webforms, special) {
    if (!webforms) return null;
    if (webforms && Object.keys(webforms).length === 0) return null;
    let result = null;
    let ids = Object.keys(webforms);
    ids = ids.sort();

    let tbody = (
      <tbody>
        {ids.map(currentId => {
          let webform = webforms[currentId];
          let isBeingAssinged = this.props.mainState.isAssigningWebform[webform.id];
          let isBeingClosed = this.props.mainState.isClosingWebform[webform.id];
          let closeWebformButton = null;
          if (webform.state.id === 356) {
            closeWebformButton = (
              <Button
                onClick={() => {
                  this.props.closeWebform(webform.id);
                  // alert("Vas a gestionar este formulario");
                }}
                color={"primary"}
                // size="sm"
                round
                icon
                disabled={isBeingClosed}
              >
                <i className={isBeingClosed ? "now-ui-icons arrows-1_refresh-69 spin reposition-spin" : "fa fa-check"} />
              </Button>
            );
          }
          let assignButton = null;
          if (webform.state.id !== 357) {
            assignButton = (
              <Button
                  onClick={() => {
                    this.props.assignWebform(webform.id, webform.state.id !== 355);
                    // alert("Vas a gestionar este formulario");
                  }}
                  color={webform.state.id === 355 ? "primary" : "danger"}
                  // size="sm"
                  round
                  icon
                  disabled={isBeingAssinged}
                >
                  <i className={isBeingAssinged ? "now-ui-icons arrows-1_refresh-69 spin reposition-spin" : (webform.state.id === 355 ? "fa fa-user-plus" : "fa fa-user-times")} />
              </Button>
            );
          }
          let agentName = "";
          if (webform && webform.agent) {
            agentName = webform.agent.username;
          }
          let detailsButton = (
            <Button
              onClick={() => {
                this.redirectTo("/web/detalles/" + webform.id);
                // alert("Vas a gestionar este formulario");
              }}
              color={"info"}
              // size="sm"
              round
              icon
              // disabled={isBeingClosed}
            >
              <i className={"now-ui-icons ui-1_zoom-bold"} />
            </Button>
          );
          let webformRow = (
            <tr 
              key={webform.id} 
              className={webform.id === this.state.webformDetailsId ? "detalle-webform" : ""}
            >
              <td>{moment(webform.date).fromNow()}</td>
              <td>{webform.name}</td>
              {special && <td>{agentName}</td>}
              <td className="text-right">
                <Button
                  onClick={() => {
                    let newWebformDetailsId = webform.id;
                    if (this.state.webformDetailsId === webform.id) {
                      newWebformDetailsId = "";
                    }
                    this.setState({ webformDetailsId: newWebformDetailsId });
                  }}
                  color="default"
                  // size="sm"
                  round
                  icon
                >
                  {/* <i className="now-ui-icons files_paper" /> */}
                  <i className={"fa fa-" + (this.state.webformDetailsId === webform.id ? "times": "align-left")} />
                </Button>{" "}
                {detailsButton}{" "}
                {assignButton}{" "}
                {closeWebformButton}
              </td>
            </tr>
          );
          let detail = this.buildWebformDetailsInTable(webform);
          if (detail) webformRow = [webformRow, detail];
          return webformRow;
        })}
      </tbody>
    );

    result = (
      <Table responsive striped style={{ overflow: "hidden" }}>
        <thead className="text-primary">
          <tr>
            <th>Fecha</th>
            <th>Formulario</th>
            {special && <th>Agente</th>}
            <th className="text-right">Acciones</th>
          </tr>
        </thead>
        {tbody}
      </Table>
    );

    return result;
  }
  buildWebformDetailsInTable(webform) {
    if (!webform) return null;
    let result = null;
    let fieldSizes = {
      xs: 12,
      md: 6,
      lg: 4
    };
    result = (
      <Row>
        {webform.fields.map(field => {
          let renderedField;
          renderedField = (
            <Col {...fieldSizes}>
              <Row>
                <Col xs={12}>
                  <b>{field.name}</b>
                </Col>
                {field.value.map((value, key) => {
                  return (
                    <Col key={field.name + "-" + key}>
                      <FormGroup>
                        <Input
                          disabled
                          type="text"
                          placeholder="1234578A"
                          value={value}
                          // onChange={event => {
                          //   let newValue = event.target.value;
                          //   this.setState({ nif: newValue });
                          //   this.validateField("nif", newValue);
                          // }}
                        />
                      </FormGroup>
                    </Col>
                  );
                })}
              </Row>
            </Col>
          );
          return renderedField;
        })}
      </Row>
    );
    return result;
  }
  validateNote() {
    let result = true;
    if (!this.state.noteText || this.state.noteText.length < 1) result = false;
    if (!this.state.noteTitle || this.state.noteTitle.length < 1) result = false;
    if (!this.state.noteType) result = false;
    return result;
  }
  clearNote() {
    this.setState({
      noteText: "",
      noteTitle: "",
      noteType: null,
      showNoteForm: false
    });
  }
  newNote() {
    if (!this.validateNote()) {
      return;
    }
    //console.log("################## SHOW POP UP CONFIRMATION ################");
    //console.log(this.state);
    this.props.userData.createNote(
      this.state.noteType.value,
      this.state.noteTitle,
      this.state.noteText,
      this.state.webform.id
    );
    this.clearNote();
  }
  createNotes() {
    try {
      let notesCardHeader = (
          <CardHeader className="txt-black">
            <h5>
              <i className="now-ui-icons design-2_ruler-pencil" /> Notas{"  "}
              <Button
                icon
                round
                key={"createNoteButton"}
                color="info"
                onClick={() => {
                  let showNoteForm = this.state.showNoteForm;
                  this.setState({ showNoteForm: !showNoteForm });
                }}
                leftLabel={"now-ui-icons " + (this.props.mainState.isCreatingNote ? "arrows-1_refresh-69 spin reposition-spin" : "ui-1_simple-add")}
              />
            </h5>
            {this.state.showNoteForm && 
            <Card>
              <CardBody>
                <Form className="form-horizontal">
                  <Row>
                    <Label md={3}>Tipo</Label>
                    <Col xs={12} md={9}>
                      <FormGroup>
                        <Select
                          className="react-select primary"
                          classNamePrefix="react-select"
                          placeholder="Tipo de nota"
                          name="noteType"
                          value={this.state.noteType}
                          options={noteType}
                          onChange={value => this.setState({ noteType: value })}
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Label md={3}>Título</Label>
                    <Col xs={12} md={9}>
                      <FormGroup>
                        <Input
                          type="text"
                          name="noteTitle"
                          placeholder="Título de la nota"
                          value={this.state.noteTitle}
                          onChange={event => this.setState({ noteTitle: event.target.value })}
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col size={12}>
                      <FormGroup>
                        <CKEditor
                          editor={ ClassicEditor }
                          config={{
                            toolbar: [
                              'heading', '|',
                              'bold', 'italic','|',
                              'link', '|',
                              'outdent', 'indent', '|',
                              'bulletedList', 'numberedList', '|',
                              'insertTable', '|',
                              'blockQuote', '|',
                              'undo', 'redo'
                            ]
                          }}
                          data={this.state.noteText}
                          onInit={ editor => {
                          } }
                          onChange={ ( event, editor ) => {
                              const data = editor.getData();
                              this.setState({ noteText: data });
                          } }
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col xs={6}>
                      <Button
                        // icon
                        // round
                        disabled={!this.validateNote()}
                        style={{ width: "100%" }}
                        color="primary"
                        onClick={() => {
                          console.log("crear nota", this.state);
                          this.newNote();
                        }}
                        leftLabel={"now-ui-icons ui-1_simple-add"}
                      >
                        {"Crear"}
                      </Button>
                    </Col>
                    <Col xs={6}>
                      <Button
                        // icon
                        // round
                        style={{ width: "100%" }}
                        color="default"
                        onClick={() => {
                          this.clearNote();
                        }}
                        leftLabel={"now-ui-icons ui-1_simple-remove"}
                      >
                        {"Cancelar"}
                      </Button>
                    </Col>
                  </Row>
                </Form>
              </CardBody>
            </Card>}
          </CardHeader>
      );
      let notesCard = null;
      let notesCardBody = null;
      let customerNotes = this.state.webform.notes;
      if (!customerNotes) customerNotes = [];
      if (customerNotes.length > 0) {
        customerNotes = customerNotes.map((note, key) => {
          if (this.filterNotes(note)) {
            let badgeStyle = {
              color: "default",
              icon: "travel_info"
            };
            if (note.tipo === "Incidencia") {
              badgeStyle.color = "danger";
              badgeStyle.icon = "ui-2_settings-90";
            }
            if (note.tipo === "Solución") {
              badgeStyle.color = "primary";
              badgeStyle.icon = "ui-2_like";
            }
            if (note.tipo === "Log") {
              badgeStyle.color = "warning";
              badgeStyle.icon = "ui-1_bell-53";
            }
            if (note.tipo === "Pago") {
              badgeStyle.color = "primary";
              badgeStyle.icon = "business_money-coins";
            }
  
            let note_text = note.texto;
            // console.log("note_text", note_text);
            try {
              let note_json = JSON.parse(note_text);
              // console.log("note_json", note_json);
              note_text = note_json.text;
            } catch (error) {
              // console.log("error", error);
              note_text = note.texto;
            }
  
            note = {
              inverted: true,
              badgeColor: badgeStyle.color,
              badgeIcon: "now-ui-icons " + badgeStyle.icon,
              title: note.autor + (note.titulo !== "" ? ": " + note.titulo : ""),
              titleColor: "danger",
              body: <div dangerouslySetInnerHTML={{ __html: note_text }} />,
              footerTitle: <div dangerouslySetInnerHTML={{ __html: note.fecha }} />
            };
            return note;
          }
        });
        customerNotes = customerNotes.filter(function (el) {
          return el != null;
        });
        notesCardBody =
          <CardBody>
            <Row>
              <Col xs={12}>
                <FormGroup>
                    <Input
                      type="text"
                      className="note-filter"
                      placeholder="Filtrar notas..."
                      value={this.state.noteFilter || ""}
                      // onChange={e => this.handleChange("searchQuery", e)}
                      onChange={e => this.setState({ noteFilter: e.target.value })}
                      // onKeyDown={this.handleKeyDown}
                      // disabled={this.props.mainState.isSearchingBuildings}
                      // onKeyDown={e => {
                      //   //console.log(e.keyCode);
                      //   if (e.keyCode == 13) {
                      //     console.log("ola k ase?");
                      //     //Enter is key code 13
                      //     // this.searchCustomer();
                      //     // put the login here
                      //   }
                      // }}
                      // style={{ marginRight: "10px" }}
                    />
                </FormGroup>
              </Col>
            </Row>
            {this.state.showNotes && <Timeline stories={customerNotes} simple />}
            <Row>
              <Col xs={12}>
                <Card 
                  onClick={() => this.setState({ showNotes: !this.state.showNotes }) }
                  color="default" 
                  style={{ overflow: "hidden" }}
                  className="text-center building-card">
                  {customerNotes.length > 0 && <CardHeader className="txt-black">
                    <i className={this.state.showNotes ? "now-ui-icons ui-1_simple-delete" : "now-ui-icons ui-1_simple-add"} /> {
                    this.state.showNotes ? "Ocultar todas" : "Mostrar todas"
                  }
                  </CardHeader>}
                  <CardBody className="text-center txt-white h3 h-nomargin">
                    {customerNotes.length + (customerNotes.length === 1 ? " nota" : " notas")}
                  </CardBody>
                  <CardFooter className="text-right txt-black">
                    <Row>
                      <Col xs={6} className="text-left txt-black">
                        {/* Pulsa para mostrar todos */}
                      </Col>
                      <Col xs={6} className="text-right txt-black">
                        {/* {mobile.precio} */}
                      </Col>
                    </Row>
                  </CardFooter>
                  {/* {coverage} */}
                </Card>
              </Col>
            </Row>
          </CardBody>;
      } else {
        notesCardBody = 
          <CardBody>
            <div>
              <i className="now-ui-icons ui-1_simple-remove" /> No hay notas
            </div>
          </CardBody>;
      }
      notesCard = (
        <Card key="notesCard" className="card-plain card-timeline">
          {notesCardHeader}
          {notesCardBody}
        </Card>
      );
      return notesCard;
      
    } catch (error) {
      return "Error al crear las notas: " + error;
    }
  }

  // El parámetro "special" es para cuando vamos a cargar datos de admin
  buildWebforms(state, title, special) {
    let result = null;
    let isCollapsed = this.isCollapsed(title);
    let webforms = this.props.mainState.webforms;
    if (webforms && special) webforms = this.props.mainState.adminWebforms;
    if (!webforms) return null;
    let ids = [];
    if (webforms) ids = Object.keys(webforms);
    if (!(!ids || ids.length === 0)) {
      let filtered_webforms = [];
      ids.map(id => {
        let webform = webforms[id];
        // console.log("Filtrando webforms: ", webform);
        if (webform.state.id === state) filtered_webforms[id] = webform;
      });
      webforms = filtered_webforms;
      if (webforms) ids = Object.keys(webforms);
    }
    let contentTable = null;
    if (!ids || ids.length === 0) {
      if (this.props.mainState.isGettingwebContent) {
        contentTable = (
          <div>
            <i className="now-ui-icons arrows-1_refresh-69 spin" /> Cargando...
          </div>
        );
      } else {
        contentTable = (
          <div>No hay formularios.</div>
        );
      }
    } else {
      contentTable = isCollapsed ? null : this.createWebformsTable(webforms, special, this.isCollapsed(title));
    }
    // console.log("webforms state (" + state + "): ", webforms);

    let collapseButton = (
      <Button
        onClick={() => {
          this.toggleCollapseForms(title);
          // alert("Vas a gestionar este formulario");
        }}
        color="default"
        size="sm"
        // round
        // icon
        // disabled={isBeingClosed}
      >
        {isCollapsed
          ? "Mostrar todos (" + Object.keys(webforms).length + ")"
          : "Ocultar"}
      </Button>
    );

    result = (
      <Card>
        <CardHeader>
          <CardTitle>{title}</CardTitle>
        </CardHeader>
        <CardBody>
          {collapseButton}
          {contentTable}
        </CardBody>
      </Card>
    );

    return result;
  }
  // Estados de los webforms:
  //  -Sin leer (355)
  //  -Gestionando (356)
  //  -Atendido (357)
  buildContent() {
    if (!this.state.webform) {
      return (
        <Row className="text-center">
          <Col xs={12}>
            <Card>
              <CardBody>
                <div>
                  <i className="now-ui-icons arrows-1_refresh-69 spin" /> Cargando formulario...
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      );
    }
    let content = null;
    let webform = this.state.webform;
    let agentName = "";
    if (webform && webform.agent) {
      agentName = webform.agent.username;
    }
    let isBeingAssinged = this.props.mainState.isAssigningWebform[webform.id];
    let isBeingClosed = this.props.mainState.isClosingWebform[webform.id];
    let closeWebformButton = null;
    if (webform.state.id === 356) {
      closeWebformButton = (
        <Button
          onClick={() => {
            this.props.closeWebform(webform.id);
            // alert("Vas a gestionar este formulario");
          }}
          color={"primary"}
          // size="sm"
          round
          icon
          disabled={isBeingClosed}
        >
          <i className={isBeingClosed ? "now-ui-icons arrows-1_refresh-69 spin reposition-spin" : "fa fa-check"} />
        </Button>
      );
    }
    let assignButton = null;
    if (webform.state.id !== 357) {
      assignButton = (
        <Button
            onClick={() => {
              this.props.assignWebform(webform.id, webform.state.id !== 355);
              // alert("Vas a gestionar este formulario");
            }}
            color={webform.state.id === 355 ? "primary" : "danger"}
            // size="sm"
            round
            icon
            disabled={isBeingAssinged}
          >
            <i className={isBeingAssinged ? "now-ui-icons arrows-1_refresh-69 spin reposition-spin" : (webform.state.id === 355 ? "fa fa-user-plus" : "fa fa-user-times")} />
        </Button>
      );
    }
    let detail = this.buildWebformDetailsInTable(webform);
    // console.log("webform detail", detail);
    content = (
      <Row>
        <Col xs={12}>
          <Card>
            <CardTitle className="text-center">
            {webform.name + " · " + moment(webform.date).fromNow() + " . " + agentName + " "}
            {assignButton}{" "}
            {closeWebformButton}
            </CardTitle>
            <CardBody>{detail}</CardBody>
          </Card>
        </Col>
        <Col xs={12}>
          {this.createNotes()}
        </Col>
      </Row>
    );
    return content;
  }
  render() {
    let contentToDisplay = this.buildContent();
    return (
      <div>
        <PanelHeader
          size="sm"
          // content={
          //   <span>Formularios web</span>
          // }
        />
        <div className="content">{contentToDisplay}</div>
      </div>
    );
  }
}

export default WebContentDetails;



// WEBPACK FOOTER //
// ./src/views/Web/WebContentDetails.jsx